import { useState } from 'react';
import { Button, Col, Row, Stack } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import editIconWhite from '../../assets/images/edit-icon-white.svg';
import plusIconWhite from '../../assets/images/plus-icon-white.svg';
import DeleteIcon from '../../assets/images/componets/DeleteIcon';
import { useLocalizedRoutes } from '../../hooks/useLocalizedRoutes';
import { LogoPetroprix } from '../ui/LogoPetroprix';
import { ModalLimitesCuenta } from './ModalLimitesCuenta';
import { ModalEliminarVehiculos } from './ModalEliminarVehiculos';

export const FlotasActions = ({
  tipoCuenta,
  onChange,
  vehiculos,
  vehicleSelected,
  setVehicleSelected,
  idClienteFlota,
}) => {
  const { t } = useTranslation();
  const { getPath } = useLocalizedRoutes();
  const { flotaActiva } = useSelector((state) => state.auth);

  const [deleteVehicles, setDeleteVehicles] = useState(1);
  const [modalDeleteVehicles, setModalDeleteVehicles] = useState({
    show: false,
    vehicles: [],
  });
  const [modalLimites, setModalLimites] = useState({
    show: false,
  });

  const changeSelectVehicles = () => {
    setDeleteVehicles(!deleteVehicles);
    eliminarVehiculos();
  };

  const eliminarVehiculos = async () => {
    const selectedVehicles = [];
    const vehicles = document.querySelectorAll('div.vehiculo');

    vehicles.forEach((vehiculo) => {
      const checkbox = vehiculo.querySelector('input[type=checkbox]');
      if (checkbox.checked) {
        const id = checkbox.value;
        const vehicle = vehiculos.find((item) => item.id_vehiculo_flota == id);
        selectedVehicles.push(vehicle.id_vehiculo_flota);
      }
    });

    if (selectedVehicles.length > 0) {
      setModalDeleteVehicles({
        show: true,
        vehicles: selectedVehicles,
      });
    } else {
      toast(t('flotas.table.seleccione-uno'), {
        icon: <LogoPetroprix />,
      });
    }
  };

  const updateRow = () => {
    onChange();
  };

  return (
    <>
      <Row className='mt-1 flotas-buttons'>
        <Col xs={12}>
          <Stack direction='horizontal' gap={2}>
            <Button
              variant='primary'
              className='flotas-btn-add ms-auto'
              onClick={() => {
                setModalLimites({ ...modalLimites, show: true });
              }}
            >
              <img src={editIconWhite} alt='' width={14} />{' '}
              {t('flotas.actions.limites-diarios')}
            </Button>

            {tipoCuenta === 'prepago' && (
              <Button
                as={Link}
                to={getPath('fleetsAddBalance')}
                variant='primary'
                className='flotas-btn-add'
              >
                <img src={plusIconWhite} alt='' width={14} />{' '}
                {t('flotas.actions.add-saldo')}
              </Button>
            )}

            <Button
              as={Link}
              to={getPath('fleetsNewVehicle')}
              variant='primary'
              className='flotas-btn-add'
            >
              <img src={plusIconWhite} alt='' width={14} />{' '}
              {t('flotas.actions.add-vehiculo')}
            </Button>

            <Button
              variant='primary'
              id='flotas-eliminar'
              className='flotas-btn-add'
              onClick={changeSelectVehicles}
              disabled={!vehicleSelected}
            >
              <span className='p-1'>
                <DeleteIcon
                  width={14}
                  strokeColor={!vehicleSelected ? '#2b363b' : '#ffffff'}
                  strokeOpacity={!vehicleSelected ? '0.25' : '1'}
                />
              </span>
              {t('flotas.table.eliminar')}
            </Button>
          </Stack>
        </Col>
      </Row>

      <ModalLimitesCuenta
        show={modalLimites.show}
        onHide={() => {
          setModalLimites({ ...modalLimites, show: false });
        }}
        idClienteFlota={idClienteFlota}
      />

      <ModalEliminarVehiculos
        show={modalDeleteVehicles.show}
        onHide={(deleted = false) => {
          if (deleted) {
            modalDeleteVehicles.vehicles.forEach(() => {
              updateRow();
            });
            setVehicleSelected(false);
          }
          setModalDeleteVehicles({ ...modalDeleteVehicles, show: false });
        }}
        vehicles={modalDeleteVehicles.vehicles}
      />
    </>
  );
};
